import React from 'react';
import Timepicker from '../Timepicker';
import moment from 'moment';
import { create } from 'react-test-renderer';
import { render, screen } from '@testing-library/react';

describe('Timepicker Component', () => {
  it('renders clock', () => {
    const name = 'clock';
    const { rerender } = render(<Timepicker hideAnalogClock={false}/>);
    expect(screen.getByRole('img', { name: new RegExp(name) })).toBeInTheDocument();

    rerender(<Timepicker hideAnalogClock/>);
    expect(screen.queryByRole('img', { name: new RegExp(name) })).not.toBeInTheDocument();
  });

  it('renders ampm', () => {
    const data = ['am', 'pm'];
    const { rerender } = render(<Timepicker hour24={false} />);
    data.forEach((text) => {
      expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'div' && content.toLowerCase() === text))
      .toBeInTheDocument();
    });
    rerender(<Timepicker hour24 />);
    data.forEach((text) => {
      expect(screen.queryByText((content, element) => element.tagName.toLowerCase() === 'div' && content.toLowerCase() === text))
        .not.toBeInTheDocument();
    });
  });

  it('renders buttons based on showConfirm', () => {
    const buttons = ['ok', 'cancel'];
    const { rerender } = render(<Timepicker showConfirm={true} />);
    buttons.forEach((button) => {
      expect(screen.getByRole('button', { name: new RegExp(`${button}`,'i') })).toBeInTheDocument();
    });
    rerender(<Timepicker showConfirm={false} />);
    buttons.forEach((button) => {
      expect(screen.queryByRole('button', { name: new RegExp(`${button}`,'i') })).not.toBeInTheDocument();
    });
  });

  describe('snapshots', () => {
    it('should match all props given with visible attributes snapshot', () => {
      const component = create(
        <Timepicker
          hour24
          locale={moment.locale()}
          hideAnalogClock={false}
          showConfirm={true}
          showSeconds={true}
          utc={moment.utc().utcOffset()}
        />
      ).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should match analog clock hidden snapshot', () => {
      const component = create(<Timepicker hideAnalogClock={true} />).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should match confirm button hidden snapshot', () => {
      const component = create(<Timepicker showConfirm={false}/>).toJSON();
      expect(component).toMatchSnapshot();
    });

    it('should match time seconds hidden snapshot', () => {
      const component = create(<Timepicker showSeconds={true}/>).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
